/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notes: [],
  currentView: 'dashboard', // 'dashboard', 'timeline', 'list', 'corkboard'
};

export const notesSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    addNote: (state, action) => {
      state.notes.unshift(action.payload);
    },
    setNotes: (state, action) => {
      state.notes = action.payload;
    },
    updateNote: (state, action) => {
      const payloadId = action.payload._id || action.payload.id || action.payload.noteId;
      const index = state.notes.findIndex(
        (note) => (note._id || note.id || note.noteId) === payloadId
      );
      if (index !== -1) {
        state.notes[index] = action.payload;
      }
    },
    removeNote: (state, action) => {
      const noteId = action.payload;
      state.notes = state.notes.filter((note) => (note._id || note.id || note.noteId) !== noteId);
    },
    clearNotes: (state) => {
      state.notes = [];
    },
    setView: (state, action) => {
      state.currentView = action.payload;
    },
  },
});

export const { addNote, setNotes, updateNote, removeNote, clearNotes, setView } =
  notesSlice.actions;

export default notesSlice.reducer;
